<template>
	<div>
		<div class="toy">
				<a href="/">
				<img src="../../assets/home.png" class="icon"/>
				</a>
			</div>
	<van-row type="flex" class="topdiv" justify-content="center"  flex-direction= "column">
		 <van-col span="6"><van-icon :name="feedback" size="60px"></van-icon></van-col>
	  <van-col span="18" class="title">意见建议</van-col>
	 </van-row>
	 <van-tabs @disabled="" @click="changeTab">
	   <van-tab title="待处理"><van-divider>共有{{rows}}记录被发现</van-divider></van-tab>
	   <van-tab title="已回复" ><van-divider>共有{{rows}}记录被发现</van-divider></van-tab>
	 </van-tabs>
	 <van-list v-for="item in orderList">
	 		  <van-cell :title="item.RecID.toString() + ' ' + item.MsgTitle" :value="item.Status"
	 		  title-class="itemtitle"
	 		  value-class="itemValue"
	 		  label-class="itemLable"
	 		  is-link to= "feedback/msginfo"
			  @click="itemClick(item.RecID)"
	 		  >		
	 		   <template slot="label">
	 		      <span>{{item.Msg}}</span>
	 			  <h4>{{item.SentTime}}</h4>
	 		    </template>
	 		  </van-cell>
	 </van-list>	
	
	<van-tabbar>	 
	  <van-tabbar-item icon="add" @click="newOrder" >新反馈</van-tabbar-item>
	</van-tabbar>
	
	</div>
</template>

<script>
	import Vue from 'vue'
	import {Dialog} from 'vant'
	var access_token ="";
	export default {
	  name: 'feedbackapp',	  
	  data(){
		  return{
			  feedback: require("@/assets/icon/feedback2.png"),
			  orderList:[],
			  rows:'0',
			  access_token
		  }
	  },
	  created(){		
		
		 var that = this;
		 //判断调用来源
		 this.access_token = that.getQueryString("access_token");;	
		 if ( this.access_token != null)
		 {
			localStorage['access_token'] = this.access_token;
			localStorage['isLogin'] = "1";
		 }
		 else
		 {
			localStorage['access_token'] = "";
			localStorage['isLogin'] = "0";
		 }	
		 this.$root.myTitle ='意见反馈';
		 this.getData('待处理');
				 
	  },
	   methods:{
		 neworder(){
				this.$router.push({ path:'/'  })
		 },
		 getQueryString(key)
		     {
		         var after = window.location.hash.split("?")[1];
		         if(after == "") return null; //如果url中没有传参直接返回空
		 
		         if(after)
		         {
		             var reg = new RegExp("(^|&)"+ key +"=([^&]*)(&|$)");
		             var r = after.match(reg);
		             if(r != null)
		             {
		                 return  decodeURIComponent(r[2]);
		             }
		             else
		             {
		                 return null;
		             }
		         }
		     },
		 getData(status){
			 var that = this;
			 var myUrl = that.global.BASE_URL_T3 + '/api/login2/mymessages?status=' + status;	
			console.log(myUrl);
			 var config = {
			   method: 'get',
			   url: myUrl,
			   headers: { 
			     'Authorization': localStorage['access_token']
			   }
			 };
			 
			 Vue.axios(config)
			 .then(function (response) {				  
			   if (response.data.Status == 0)
			   {
			   	that.orderList = response.data.Data;
				that.rows = response.data.Data.length;
			   }	
				console.log(that.orderList);
			 })
			 .catch(function (error) {
			   console.log(error);
			 });			 
			},
		changeTab(name,title){
			this.getData(title);
		},
		newOrder(){
			this.$router.push({ path:'/feedback/newmsg'  })
		},
		itemClick(e){
			console.log(e)
			this.$root.common.curorderid = e;
		}
			
		}	
	}
	
</script>

<style>
	.item{
		margin-top: 1px;
	}
	.topdiv{
		  height: 100px;
		  background-color: #D74A43;
		  color: #FFFFFF;
		  display: flex;
		  align-items: center;  
		  justify-content: center; 	 
	}
	.title{
		  font-size: 28px;
	}
	.itemLable{
		text-align: left;
		font-size: 12px;
		padding: 10px;
		width: 100%;
	}
	.itemtitle{
		font-weight: bold;
		text-align: left;
	}
	.itemValue{
		color:red;
	} 
	/*div通用样式*/
  .toy{
	right: calc(5%);
	bottom: calc(10%);	
  color:#ffffff;
  overflow: hidden;
  z-index: 9999;
  position: fixed;
  text-align:center;
  border-radius: 20px;
  height: 40px;
  width: 40px;
  padding:5px;
  box-shadow: 1px 1px 1px #A0A0A0;
  }
	.icon{
		  max-width: 40px;
	}
</style>
